import React, { useRef } from "react";
import config from "../../../config/index.js";
import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";

function ImageElement({ previewSource = "", source, userType = "common", fallbackSource = "default-img.webp", alt = "image", isLightbox = true, ...rest }) {
  const galleryRef = useRef(null);
  const imageUrl = {
    admin: config.ADMIN_IMAGE_URL,
    user: config.IMAGE_URL,
    super: config.SUPER_IMAGE_URL,
    common: config.COMMON_IMAGE_URL,
    userLanding: config.LANDING_IMAGE_URL,
  }

  // Determine the final source URL
  const finalSrc = previewSource || `${imageUrl[userType]}/${source}`;

  // Clean up path if needed (copied from ReviewImageGallery logic just in case, though likely handled by browser)
  // const cleanSrc = finalSrc.replace(/\\\\/g, "/").replace(/\\/g, "/"); 
  // keeping it simple as per original ImageElement for now.

  const openGallery = () => {
    // Create a dynamic instance
    const instance = lightGallery(document.createElement("div"), {
      dynamic: true,
      dynamicEl: [
        {
          src: finalSrc,
          thumb: finalSrc,
        },
      ],
      licenseKey: "0000-0000-0000-0000",
      plugins: [lgThumbnail, lgZoom],
      download: false,
      thumbnail: true,
      zoom: true,
    });
    instance.openGallery(0);
    // Note: LightGallery destroys itself when closed if dynamic? 
    // Actually typically one should destroy it. 
    // Let's attach a listener to destroy on close if possible, or just let it be. 
    // The "document.createElement('div')" is not attached to DOM, so it might leak if not destroyed.
    // However, lightGallery appends to body.
    // Let's rely on standard behavior or add a listener. 
    // instance.on('lgAfterClose', () => instance.destroy()); // hypothetical API
  };

  return (
    <img
      src={finalSrc}
      alt={alt}
      onClick={isLightbox ? openGallery : undefined}
      // style={{ ...rest.style }} // Ensure pointer cursor
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = `${imageUrl.common}/${fallbackSource}`;
      }}
      {...rest}
    />
  );
}

export default ImageElement;
